module.exports = __webpack_public_path__ + "img/arrow-rt.450f7067.svg";